interface DispositionOption {
    disposition_id: number;
    disposition_name: string;
    disposition_label: string;
}

export const interactionAuditDispositionOptions: Record<string, DispositionOption[]> = {
    "Genuine": [
        { disposition_id: -1, disposition_name: "Genuine", disposition_label: "Genuine" },
    ],
    "Likely Genuine": [
        { disposition_id: -2, disposition_name: "Location Within Range", disposition_label: "Location Within Range" },
        { disposition_id: -3, disposition_name: "Image Confirmed", disposition_label: "Image Confirmed" },
        { disposition_id: -4, disposition_name: "Other", disposition_label: "Other" }
    ],
    "Fake": [
        { disposition_id: -5, disposition_name: "Invalid Image", disposition_label: "Invalid Image" },
        { disposition_id: -6, disposition_name: "Invalid Disposition", disposition_label: "Invalid Disposition" },
        { disposition_id: -7, disposition_name: "Invalid Location", disposition_label: "Invalid Location" },
        { disposition_id: -8, disposition_name: "All Inputs Invalid", disposition_label: "All Inputs Invalid" }
    ]
};